export class ApplicationSendResponse {
  public new: number;
  public resend: number;
  public total: number;
  public sent: number;

  public static parse(data: any): ApplicationSendResponse {
    let obj = new ApplicationSendResponse();
    obj.new = data.new;
    obj.resend = data.resend;
    obj.total = data.total;
    obj.sent = data.sent;
    return obj;
  }
}
